import { Editor } from '@tinymce/tinymce-react';
import { Editor as TinyMCEEditor } from 'tinymce';
import React, { useRef, useState } from 'react';
import { debounce } from 'lodash';
import axios, { AxiosError, RawAxiosRequestHeaders } from 'axios';
import { useAuth0 } from '@auth0/auth0-react';
import SpinnerModal from 'Components/SpinnerModal';
import { Navigate } from 'react-router-dom';
import { useQuery } from 'react-query';
import { ClipLoader } from 'react-spinners';
import { IImage } from 'Admin/Images/IImage';

const pageStyle: React.CSSProperties = {
  textAlign: 'left'
}

const gridStyle: React.CSSProperties = {
  display: 'grid',
  gridTemplateColumns: '200px auto',
  maxWidth: '1000px',
  columnGap: '1em',
  rowGap: '.5em',
  fontSize: '1.5em'
}

const newsImageStyle: React.CSSProperties = {
  maxWidth: '100px',
  width: '100%'
}

function NewNewsItem() {
  const { user, getAccessTokenSilently, isLoading: auth0Loading } = useAuth0();

  const newsURL = `${process.env.REACT_APP_BACKEND_URL}news`;
  const initialValues = {
    title: '',
    content: '',
    itemImage: ''
  }
  const getImages = async () => {
    let header: RawAxiosRequestHeaders = {
      'Content-Type': 'application/json'
    }
    const accessToken = await getAccessTokenSilently();
    header.Authorization = `Bearer ${accessToken}`;
    const imageUrl = `${process.env.REACT_APP_BACKEND_URL}images`;
    const data = await (await axios.get<any>(imageUrl, {
      headers: header
    })).data
    const mappedImages: { display: string, value: string, imageType?: string }[] =
      data.images.filter((x: IImage) => !x.hidden).map((x: IImage) => {
        return {
          display: x.name,
          value: x.imageUrl,
          imageType: x.imageType
        }
      })

    const newsPics = mappedImages.filter(x => x.imageType === 'newsPhoto')
    setNewsItemPhotos(newsPics);
    return data;
  }
  const [values, setValues] = useState(initialValues);
  const [saving, setSaving] = useState(false);
  const [newsItemPhotos, setNewsItemPhotos] = useState<{ display: string, value: string, imageType?: string }[]>([]);
  const editorRef = useRef<TinyMCEEditor | null>(null)

  const { status } = useQuery('advertisementPhotos', getImages, {
    enabled: (!auth0Loading && user?.['peloestudo/roles'].includes('Owner'))
  })

  if (user && (!user['peloestudo/roles'].includes('Admin'))) {
    return (<Navigate to="/News" />)
  }



  const handleChange = (e: (React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLTextAreaElement> | React.ChangeEvent<HTMLSelectElement>)) => {
    setValues({
      ...values,
      [e.target.name]: e.target.value
    })
  }
  const isFormValid = () => {
    return (values.title?.length > 0 && values.content?.length > 0)
  }
  const handleBlur = (e: (React.FocusEvent<HTMLInputElement> | React.FocusEvent<HTMLTextAreaElement>)) => {
    setValues({
      ...values,
      [e.target.name]: e.target.value
    })
  }
  const debouncedHandler = debounce(handleChange, 500);
  const save = async () => {
    setSaving(true)
    const accessToken = await getAccessTokenSilently();
    let header: RawAxiosRequestHeaders = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${accessToken}`
    }
    const postBody: {
      content: string,
      title: string,
      itemImage?: string
    } = {
      content: values.content,
      title: values.title,
      itemImage: values.itemImage
    }
    axios.post(newsURL, postBody, {
      headers: header
    }).then(res => {
      console.log(res)
      alert('save successful')
    }).catch((err: AxiosError | Error) => {
      if (axios.isAxiosError(err)) {
        console.error(err.response?.data);
      }
      alert('save failed')
    }).finally(() => {
      setSaving(false)
    })
  }
  const handleEditorChange = (newValue: string) => {
    setValues({
      ...values,
      content: newValue
    })
  }
  return (
    <section style={pageStyle}>
      <h2>Envie Seu Artigo Aqui</h2>
      <div style={gridStyle}>
        <label>T&iacute;tulo da Not&iacute;cia:
        </label>
        <input
          type="text"
          name="title"
          onChange={debouncedHandler}
          onBlur={handleBlur}
          defaultValue={values.title}
        />
        {status === 'loading' &&
          (
            <div><ClipLoader /></div>
          )
        }
        {
          status === 'error' &&
          (
            <div>Error loading images</div>
          )
        }
        {
          status === 'success' && newsItemPhotos.length > 0 &&
          (<><label>Imag&eacute;m da Not&iacute;cia</label>
            <div>
              {values.itemImage &&
                <div>
                  <img src={values.itemImage} alt={values.title} style={newsImageStyle} />
                </div>
              }
              <select value={values.itemImage} name="itemImage" onChange={handleChange}>
                {!values.itemImage &&
                  <option></option>
                }
                {newsItemPhotos.map(x => {
                  return <option value={x.value}>{x.display}</option>
                })}
              </select>
            </div>
          </>)
        }
      </div>

      <Editor
        apiKey='c27sqmj1ce4fnrsz5n0bcciljvxysmhsu5mjm3jzxdr24amf'
        onInit={(evt, editor) => editorRef.current = editor}
        onEditorChange={(newValue, editor) => handleEditorChange(newValue)}
        value={values.content}
        init={{
          height: 500,
          plugins: 'preview code',
          toolbar: [
            { name: 'history', items: ['undo', 'redo'] },
            { name: 'styles', items: ['styles'] },
            { name: 'formatting', items: ['bold', 'italic', 'blockquote'] },
            { name: 'alignment', items: ['alignleft', 'aligncenter', 'alignright', 'alignjustify', 'alignnone'] },
            { name: 'indentation', items: ['outdent', 'indent'] },
            { name: 'preview', items: ['preview', 'code'] }
          ]
        }}
      />
      <button onClick={save} disabled={!isFormValid() || saving}>Submit</button>
      {
        saving &&
        <SpinnerModal
          spinnerText="Salvando Notícia"
        />
      }
    </section>
  );
}

export default NewNewsItem;